import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { removeMaintenanceServiceImage } from '../../api/maintenance-service.ts';
import { RemoveMaintenanceServiceImageRequest } from '../../api/requests/maintenance-service-request.ts';

export default function useRemoveMaintenanceServiceImage(): UseMutationResult<
  Awaited<ReturnType<typeof removeMaintenanceServiceImage>>,
  Error,
  RemoveMaintenanceServiceImageRequest
> {
  return useMutation({
    mutationFn: removeMaintenanceServiceImage,
  });
}
